import React, { useState } from 'react';
import classes from './Contacts.module.scss';

// import penSvg from '../../assets/images/pen.svg';
import iexSvg from '../../assets/images/indian-expres.svg';
import dtnSvg from '../../assets/images/dt-next.svg';
import signSvg from '../../assets/images/sign.svg';
import cardSvg from '../../assets/images/card.svg';

import BigButton from '../UI/BigButton/BigButton';
// import ScrollInfo from '../UI/ScrollInfo/ScrollInfo';

const formInitialData = [
  {
    id: 'input-name',
    type: 'input',
    element: 'input',
    label: 'Enter your name',
    config: {
      type: 'text',
      value: ''
    }
  },
  {
    id: 'input-email',
    type: 'input',
    element: 'input',
    label: 'Enter your Email',
    config: {
      type: 'email',
      value: ''
    }
  },
  {
    id: 'input-country',
    type: 'input',
    element: 'input',
    label: 'Country',
    config: {
      type: 'text',
      value: ''
    }
  },
  {
    id: 'input-number',
    type: 'input',
    element: 'input',
    label: 'Mobile number',
    config: {
      type: 'text',
      value: ''
    }
  },
  {
    id: 'input-message',
    type: 'input',
    element: 'textarea',
    label: 'Write your message here',
    config: {
      type: 'text',
      value: ''
    },
    full: true
  },
];

const Input = ({ id, element, config, changed, className })=> {
  return element === 'textarea' 
    ? <textarea id={id} className={className} {...config} onChange={changed} />
    : <input id={id} className={className} {...config} onChange={changed} />;
}

const Contacts = ({ maskSize, setMaskSize, isMobile, toTop  }) => {
  const [formData, setFormData] = useState(formInitialData);

  const setFormItem = (index, value) => {
    setFormData(prevData => {
      const newData = [...prevData];
      const newItem = {...newData[index]}
      newItem.config = {
        ...newItem.config,
        value: value
      };
      newData[index] = newItem;
      return newData;
    })
  }

  return (
    <div className={classes.Contacts}>

      {/* <ScrollInfo small={isMobile} parentClass={classes.Contacts}
      >
        Back to top
      </ScrollInfo> */}
      
      <div className={classes.Contents}>

        <div className={classes.Top}>
          <div className={classes.Left}>
            <div className={classes.TextContents}>
              <h2 className={classes.Title}>Say Vanakkam! <span role="img" aria-label="imo">🙏</span></h2>

              <p className={classes.Details}>Enter your collaboration details / feedback below and I'll get back to you as soon as I can!</p>
            </div>

            <form action="" className={classes.Form}>
              <div className={classes.Inputs}>
                {formData.map((formItem, i) => {
                  const classNames = [classes.FormControl];
                  if (formItem.config.value !== '') classNames.push(classes.Active);
                  if (formItem.full) classNames.push(classes.Full);

                  return (
                    <div className={classNames.join(' ')} key={formItem.id}>
                      <label className={classes.Label} htmlFor={formItem.id}>{formItem.label}</label>

                      <Input className={classes.Input} id={formItem.id} 
                        element={formItem.element} config={formItem.config} 
                        changed={(e)=> setFormItem(i, e.target.value)}
                      />
                    </div>
                  );
                })}
              </div>
              
              <div className={classes.ButtonDiv}>
                <BigButton type="submit" className={classes.BtnSubmit}>Submit</BigButton>
              </div>
            </form>
          </div>
          <div className={classes.Right}>
            <div className={classes.Resume}>
              <img src={cardSvg} alt="C" className={classes.Card} />

              <div className={classes.TextContents}>
                <h3 className={classes.Name}>Akash Sekar</h3>
                <p className={classes.Email}>Hello@AkashOfficial.com</p>
              </div>

              <BigButton className={classes.DownloadBtn}>Download Resume</BigButton>
            </div>

            <div className={classes.Featured}>
              <p className={classes.Text}>Featured in</p>

              <div className={classes.Images}>
                <a href="https://www.edexlive.com/people/2019/nov/06/how-this-military-man-turned-photographer-is-capturing-the-essence-of-chennais-street-life-8924.html" target="_blank" rel="noopener noreferrer" className={classes.ImageContainer}>
                  <img src={iexSvg} alt="IMG" className={classes.Image} />
                </a>
                <a href="https://www.dtnext.in/News/City/2019/11/19012129/1198497/Shutterbug-hits-city-streets-to-capture-human-emotions.vpf" target="_blank" rel="noopener noreferrer" className={classes.ImageContainer} style={{ transform: 'scale(0.72)' }}>
                  <img src={dtnSvg} alt="IMG" className={classes.Image} />
                </a>
              </div>
            </div>
          </div>

          <BigButton className={classes.TopButton} clicked={toTop}>
            <div className={classes.Arrow}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
                style={{ transform: 'rotate(-90deg)' }}
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
                  </g>
                </g>
              </svg>
            </div>
          </BigButton>
        </div>
        <div className={classes.Bottom}>
          <div className={classes.Left}>
            <div className={classes.Sign}>
              <img src={signSvg} alt="IMG" className={classes.Image} />
            </div>
          </div>
          <div className={classes.Right}>
            <p className={classes.Text}>&copy; 2020 <span>Sekar Akash</span>, All Rights Reserved</p>
          </div>
        </div>

      </div>

    </div>
  );
}

export default Contacts;